<div class="modal-header">
    <h4 class="modal-title">Complete Order</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    @if(completeOrderForm !== undefined && completeOrderForm !== null){
        <form [formGroup]="completeOrderForm">
          <div class="row">
            <label class="col-12 text-md-start mogo-bold">Received By</label>
          </div>
          <div class="row mb-2" >
            <div class="col-12" >
                <div class="input-group">
                    <input
                        class="form-control required"
                        placeholder="Please enter received by"
                        formControlName="receivedBy"
                        id="received-by-input"
                        type="text"
                    />
                </div>
            </div>
        </div>
        <div formGroupName="completedDate">
          <div class="row">
            <label class="col-12 text-md-start mogo-bold">Completed Date</label>
          </div>
          <div class="row mb-2" >
            <div class="col-12" >
                <div class="input-group">
                    <input
                        class="form-control"
                        placeholder="Delivery Date"
                        name="dp"
                        formControlName="date"
                        ngbDatepicker
                        #startDatePicker="ngbDatepicker"
                        id="start-date-input"
                    />
                    <button class="btn btn-outline-secondary py-1" (click)="startDatePicker.toggle()" type="button">
                        <ng-icon name="bootstrapCalendarFill" size></ng-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
          <label class="col-12 text-md-start mogo-bold">Completed Time</label>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <ngb-timepicker id="start-time-input" formControlName="time" [meridian]="true" [spinners]="false" ></ngb-timepicker>
          </div>
        </div>

      </div>
      <div class="row">
        <label class="col-12 text-md-start mogo-bold">Upload Proof of Deliveries</label>
      </div>
      <div class="row">
        <div class="col-12">
          <app-mogo-dropzone formControlName="podAttachments" height="250px"></app-mogo-dropzone>
        </div>
      </div>
    </form>
    }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="clear()">Clear</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Close</button>
  <button type="button" class="btn btn-primary" (click)="completeOrder()">Save changes</button>
</div>
